import Vue from 'vue'
import '../components';
import VueRouter from 'vue-router';
import {replace} from 'lodash';
import Responsive from '../mixins/responsive'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
});

Vue.filter('formatNumber', function (value) {
    return ("0" + value).slice(-2);
});



Vue.filter('removeBr', function (value) {
    return replace(value, '<br>', '');
});

export default {
    vueInstance:null,
    init() {

        this.vueInstance = new Vue({
            el: '#app',
            mixins: [Responsive],
            router,
            data: {
            },
            computed: {},
            methods: {
            },
            created() {
            },
            mounted(){
            }
        });

    }

};